// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1R91a","list":"BalanceDue_list__jGZzc","listRow":"BalanceDue_listRow__1V3H5","total":"BalanceDue_total__1sK3W"};